import * as yup from 'yup';

export const commonTaxMappingValidation: { [x: string]: any; } = {
    percentage: yup.number().required("Missing.").moreThan(-0.01, "Tax% must be range from 0 to 100").lessThan(100.001, "Tax% must be range from 0 to 100"),
    taxCode: yup.string().required("Missing."),
    effectiveDate: yup.date().required("Missing."),
    paymentTerm: yup.number().required("Missing.").min(0, "Tax Payment Term(Invoice) must be greater than 0"),
    paymentTermCredit: yup.number().required("Missing.").min(0, "Tax Payment Term(Credit) must be greater than 0"),
    paymentTermDebit: yup.number().required("Missing.").min(0, "Tax Payment Term(Debit) must be greater than 0"),
    statementCode: yup.string().required("Missing."),
    paymentReferenceDate: yup.string().required("Missing."),
    paymentReferenceDateCredit: yup.string().required("Missing."),
    paymentReferenceDateDebit: yup.string().required("Missing."),
    tariffType: yup.string().required("Missing."),
    tariffCode: yup.string().required("Missing."),
    activeInd: yup.string().required("Missing."),
};

export const createTaxMappingValidation: { [x: string]: any; } = {
    ...commonTaxMappingValidation,
};

export const createTaxMappingValidationSchema = yup.object().shape(createTaxMappingValidation);

